/**
 * @file
 * Javascript for the Geolocation map formatter.
 */

(function ($, Drupal) {
  "use strict";

  /**
   * Find and display all maps.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches Geolocation Maps formatter functionality to relevant elements.
   */
  Drupal.behaviors.geolocationMap = {
    /**
     * @param context
     * @param drupalSettings
     * @param {Object} drupalSettings.geolocation
     */
    attach: function (context, drupalSettings) {
      $(".geolocation-map-wrapper")
        .once("geolocation-map-processed")
        .each(function (index, item) {
          initMap(item);
        });

      function initMap(map) {
        var $map = $(map);
        $map.$select = $map.find(".js-location-select");
        $map.$container = $map.children(".geolocation-map-container");
        $map.$locations = $map.find(".js-location");

        $map.showLocation = function (id) {
          if (!id) {
            return;
          }

          var $location;

          // Hide locations
          $.each($map.$locations, function (i, location) {
            $(location).addClass("hidden");
          });

          // Get selected location
          $location = $map.$locations.filter(function () {
            return $(this).data("id") == id;
          });

          // Show location
          $location.removeClass("hidden");

          // Set select option
          $map.$select
            .find("option[value=" + id + "]")
            .prop("selected", "selected");

          // Return if map is not loaded
          if (typeof $map.map.markers == "undefined") {
            return;
          }

          var marker = $map.map.markers[id];
          if (!marker) return;

          // Deselect markers
          $.each($map.map.markers, function (i, marker) {
            marker.setIcon($inactiveMarker);
          });

          // Set active marker
          marker.setIcon($activeMarker);
        };

        $map.$select.change(function () {
          window.location.hash = $(this).val();
        });

        $(window).on("hashchange", function (e, initial) {
          $map.showLocation(window.location.hash.replace("#", ""));
        });

        // Return here if google maps is not loaded
        if (typeof google == "undefined") {
          $map.$container.addClass("geolocation-map-container--nomap");
          $map.find(".locations").addClass("locations--nomap");
          $(window).trigger("hashchange");
          return;
        }

        var $inactiveMarker = new google.maps.MarkerImage(
          "/" + drupalSettings.path.theme + "/images/svg/icon-pinblue.svg",
          new google.maps.Size(32, 32),
          new google.maps.Point(0, 0),
          new google.maps.Point(7, 21),
          new google.maps.Size(16, 23)
        );

        var $activeMarker = new google.maps.MarkerImage(
          "/" + drupalSettings.path.theme + "/images/svg/icon-pinorange.svg",
          new google.maps.Size(32, 32),
          new google.maps.Point(0, 0),
          new google.maps.Point(7, 21),
          new google.maps.Size(16, 23)
        );

        var bounds = new google.maps.LatLngBounds();
        $map.map = new google.maps.Map($map.$container[0], {
          center: new google.maps.LatLng(25, 25),
          zoom: 3,
          minZoom: 3,
          backgroundColor: "none",
          markers: {},
          disableDefaultUI: true,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
          scrollwheel: false,
        });

        $map.map.mapTypes.set(
          "styledmap",
          new google.maps.StyledMapType(style)
        );
        $map.map.setMapTypeId("styledmap");

        $map.$locations.each(function (index, item) {
          var $item = $(item),
            id = $item.data("id"),
            position = new google.maps.LatLng(
              $item.data("lat"),
              $item.data("lng")
            ),
            marker;

          marker = new google.maps.Marker({
            position: position,
            map: $map.map,
            id: id,
            icon: $inactiveMarker,
          });

          bounds.extend(position);
          $map.map.markers[id] = marker;

          marker.addListener("click", function () {
            window.location.hash = marker.id;
          });
        });

        $(window).trigger("hashchange");
      }
    },
    detach: function (context, drupalSettings) {},
  };

  var style = [
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#444444",
        },
      ],
    },
    {
      featureType: "administrative.country",
      elementType: "geometry.stroke",
      stylers: [
        {
          color: "#3c3c3c",
        },
        {
          weight: "0.5",
        },
      ],
    },
    {
      featureType: "administrative.country",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "administrative.province",
      elementType: "labels",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#e8e8e8",
        },
      ],
    },
    {
      featureType: "landscape.man_made",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#c2c2c2",
        },
      ],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [
        {
          saturation: -100,
        },
        {
          lightness: 45,
        },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified",
        },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off",
        },
      ],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#3c3c3c",
        },
        {
          visibility: "on",
        },
      ],
    },
  ];
})(jQuery, Drupal);
